<template>
  <div class="rotationList">
    <!-- 表格 -->
    <el-card>
      <!-- 新增 -->
      <el-button type="primary" slot="header" @click="onAdd">{{$t('lang.btn_add')}}</el-button>
      <!-- 删除 -->
      <el-button type="primary" slot="header" @click="onDelete">{{$t('lang.btn_delete')}}</el-button>
      <el-table
        class="wid100"
        :data="tableData"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
        <!-- 复选框 -->
        <el-table-column type="selection" align="center" width="55"></el-table-column>
        <!-- 序号 -->
        <el-table-column type="index" align="center" :index="indexMethod" :label="$t('lang.lab_number')" width="100px"></el-table-column>
        <!-- 图片 -->
        <el-table-column prop="banner" align="center" :label="$t('lang.lab_pic')">
          <template slot-scope="scope">
            <viewer :images="[scope.row.banner.toString()]">
              <img :src="scope.row.banner" class="img"/>
            </viewer>
          </template>
        </el-table-column>
        <!-- 跳转链接 -->
        <el-table-column prop="isJump" :label="$t('lang.lab_jumpUrl')">
          <template slot-scope="scope">
            <!-- 0: 无 -->
            <span v-if="scope.row.isJump === false">{{$t('lang.CarouselMng_isJump[0].name')}}</span>
            <!-- 1: 有 -->
            <span v-if="scope.row.isJump === true">{{$t('lang.CarouselMng_isJump[1].name')}}</span>
          </template>   
        </el-table-column>
        <!-- 状态 -->
        <el-table-column prop="bannerStatus" :label="$t('lang.lab_bannerStatus')">
          <template slot-scope="scope">
            <!-- 0: 禁用 -->
            <span v-if="scope.row.bannerStatus === 0">{{$t('lang.CarouselMng_status[1].name')}}</span>
            <!-- 1: 正常 -->
            <span v-if="scope.row.bannerStatus === 1">{{$t('lang.CarouselMng_status[2].name')}}</span>
          </template>          
        </el-table-column>
        <!-- 操作 -->
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" fixed="right" >
          <template slot-scope="scope">
            <el-button v-if="scope.$index !== 0" @click="onMove(scope.row.id,-1)">{{$t('lang.btn_moveUp')}}</el-button>
            <el-button v-if="(scope.$index + 1) !== tableData.length" @click="onMove(scope.row.id,1)">{{$t('lang.btn_moveDown')}}</el-button>
            <el-button @click="onEdit(scope.row)">{{$t('lang.btn_edit')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </el-card>
    <!-- 新增编辑 -->
    <el-dialog 
      :title="isTitle"
      :visible.sync="isShow" 
      :close-on-click-modal="false"
      :destroy-on-close="true"
      center
      top="130px"
      width="600px"
      v-if="isShow"
      @close="handleDialogClosed">
      <el-form :model="form" :rules="rules" ref="form" label-width="120px" label-suffix=":">
        <!-- 状态 -->
        <el-form-item prop="bannerStatus" :label="$t('lang.lab_bannerStatus')">
          <el-select v-model="form.bannerStatus" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_bannerStatus')">
            <el-option
              v-for="(item,index) in status"
              :key="index"
              :value="item.id"
              :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 图片 -->
        <el-form-item prop="banner" ref="banner" :label="$t('lang.lab_pic')">
          <el-upload
              :before-upload="beforeAvatarUpload"
              :class="{imgDisabled:imgMax}"
              ref="uploading"
              accept=".jpg,.jpeg,.png" 
              :on-success="handleSuccess"
              :on-remove="handleRemove"
              :on-exceed="outlimit"
              :on-error="uploadErr"
              :limit="1"
              name="files"
              :action="require('@/config/enum').actionname"
              list-type="picture-card"
              :file-list="fileList"
            >
              <el-button size="small" type="primary">{{$t('lang.btn_upload')}}</el-button>
              <div class="el-upload__tip" slot="tip">{{$t('lang.tip_upload_img')}}</div>
          </el-upload>
        </el-form-item>
        <!-- 跳转链接 -->
        <el-form-item prop="isJump" :label="$t('lang.lab_jumpUrl')">
          <el-switch v-model="form.isJump" active-color="#13ce66" inactive-color="#ff4949" @change="changeSwitch"></el-switch>
        </el-form-item>
        <!-- 跳转地址 -->
        <el-form-item prop="jumpUrl" :label="$t('lang.lab_jumpAdd')" v-if="form.isJump === true">
          <input style="display: none"/>
          <el-input v-model="form.jumpUrl" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_jumpAdd')+$t('lang.lab_jumpAddInput')" maxlength="255"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="toCancel">{{$t('lang.btn_cancel')}}</el-button>
        <el-button type="primary" @click="toSave('form')" :disabled="isDisabled">{{$t('lang.btn_confirm')}}</el-button>
      </div>
    </el-dialog> 
  </div>
</template>

<script>
/**
 *@ClassName:rotationList
 *@Description:轮播图管理
 *@author:宋莎
 *@Copyright:美再晨
 *@date:2020-07-16
 */

export default {
  name: '',
  components: {},
  data() {
    return {
      imgMax: false,
      isShow: false, // 新增编辑dialog的显示控制
      isTitle: this.$i18n.t('lang.btn_add'), // 新增编辑dialog的title
      isDisabled: true, // 确定按钮置灰
      /* 轮播图列表变量 */
      multipleSelection: [], // 复选框
      pageNum: 1, // 页数
      pageSize: 10, // 每页显示数量
      total: 0, // 数据总数
      tableData: [], // 列表数据
      /* 轮播图详情(新建编辑)变量 */
      rules: {
        bannerStatus: [{ required: true, message: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_bannerStatus'), trigger: 'change' }],
        banner: [{ required: true, message: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_pic'), trigger: 'change' }],
        isJump: [{ required: true, message: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_jumpUrl'), trigger: 'change' }],
        jumpUrl: [{ required: true, message: this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_jumpAdd'), trigger: 'blur' }],
      },
      status: this.$i18n.t('lang.CarouselMng_status'), // 状态下拉list
      fileList: [], // 图片上传
      form: {
        id: '',
        bannerStatus: '',
        banner: '',
        isJump: false,
        jumpUrl: '',
      }, // 详细数据
    }
  },
  computed: {},
  watch: {
    form: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          // 没变
          this.isDisabled = true
        } else {
          // 变了
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
     beforeAvatarUpload(file) {
       if (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png') {
  
       } else {
         this.$message.error(this.$i18n.t('lang.tip_upload1'))
         return false
       }
     },
    // 获取轮播图列表数据
    getData() { 
      this.$get(`/sys/getBannerListAll?pageNum=${this.pageNum}&pageSize=${this.pageSize}`).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 查询
    onSearch(flag) { 
      if (flag) {
        this.pageNum = 1
      }
      this.$get(`/sys/getBannerListAll?pageNum=${this.pageNum}&pageSize=${this.pageSize}`).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )      
    },
    // 新增
    onAdd() {
      console.log('onAdd')
      this.isTitle = this.$i18n.t('lang.btn_add')
      this.fileList = []
      this.imgMax = false
      this.form.id = ''
      this.form.bannerStatus = ''
      this.form.banner = ''
      this.form.jumpUrl = ''
      this.form.isJump = false
      this.isShow = true
    },
    // 删除
    onDelete() { 
      console.log('onDelete')
      var array = []
      for (let index = 0; index < this.multipleSelection.length; index++) {
        array.push(this.multipleSelection[index].id)
      }
      if (array.length === 0) {
        this.$message.error(this.$i18n.t('lang.warning_selectOneDelete'))
        return        
      }
      let loading = this.$loading()
      this.$confirm(this.$i18n.t('lang.lab_isDelete'), this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
          this.$delete(`/sys/banner/${array}`).then(
            res => {
              loading.close()
              if (res && res.code === 200) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_delSuccess')
                })
                // 更新tableData
                this.onSearch(true)
              } else {
                this.$message.error(res.message)              
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )   
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_delCancel')
          })
        })  
    },
    // 编辑
    onEdit(data) {
      console.log('onEdit', data)
      this.isTitle = this.$i18n.t('lang.btn_edit')
      this.form.id = data.id
      this.form.bannerStatus = data.bannerStatus
      this.form.banner = data.banner
      if (this.form.banner !== '') {
        this.imgMax = true
      }
      this.form.jumpUrl = data.jumpUrl
      this.form.isJump = data.isJump
      // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
      this.saveData = JSON.stringify(this.form)
      this.changeData()
    },
    // 数据转换
    changeData() {
      // 转换轮播图
      this.fileList = []
      if (this.form.banner && this.form.banner !== null) {
        this.fileList.push({
          name: '',
          url: this.form.banner.toString()
        })
      }
      this.isShow = true
    },
    // 保存
    toSave(formName) { 
      console.log('toSave')
      if (this.form.isJump) {
        this.rules.jumpUrl[0].required = true
      } else {
        this.rules.jumpUrl[0].required = false
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = this.form
          this.$postJson('/sys/banner', params).then(
            res => {
              if (res && res.code === 200) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_modifySuccess')
                })
                this.handleDialogClosed()
                // 更新列表
                this.onSearch(true)
              } else {
                this.$message.error(res.message)
              }
            },
            error => {
              this.$message.error(error)
            }
          )
        } else {
          return false
        }
      })
    },
    // 取消
    toCancel() {
      console.log('toCancel')
      this.isShow = false
      this.$refs.form.clearValidate()
      this.fileList = []
      this.form.id = ''
      this.form.bannerStatus = ''
      this.form.banner = ''
      this.form.jumpUrl = ''
      this.form.isJump = false
    },
    // 移动
    onMove(id, action) { 
      let params = {
        bannerId: id,
        behaviour: action        
      }
      this.$patch('/sys/banner', params).then(
        res => {
          if (res && res.code === 200) {
            this.onSearch(true)
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      ) 
    },
    // 跳转链接开关
    changeSwitch(value) {
      console.log('跳转链接开关', value)
      if (value) {
        this.rules.jumpUrl[0].required = true
        this.$refs.form.validateField('jumpUrl')
      } else {
        this.rules.jumpUrl[0].required = false
      }
    },
    // 监听关闭'新建编辑'dialog
    handleDialogClosed() {
      console.log('handleDialogClosed')
      this.isShow = false
      this.$refs.form.clearValidate()
      this.fileList = []
      this.form.id = ''
      this.form.bannerStatus = ''
      this.form.banner = ''
      this.form.jumpUrl = ''
      this.form.isJump = false
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNum = val
      this.onSearch(false)
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.onSearch(false)
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 多选框
    handleSelectionChange(val) {
      console.log('多选', val)
      this.multipleSelection = val
    },
    // 上传数量超过提醒
    outlimit() {
      this.$message.warning(this.$i18n.t('lang.warning_uploadLimit'))
    },
    // 图片上传
    handleSuccess(response, file, fileList) {
      console.log('Upload Success!', file, fileList)
      this.imgMax = true
      this.fileList = fileList
      this.form.banner = file.response.data[0]
      this.$refs.banner.clearValidate() 
      // 由于服务器图片地址没有用户权限会上传失败
      // if (file.response && file.response.code === 200) {
      //   this.imgMax = true
      //   this.fileList = fileList
      //   this.form.banner = file.response.data[0]
      //   this.$refs.banner.clearValidate()        
      // } else {
      //   this.imgMax = false
      //   this.fileList = []
      //   this.form.banner = ''
      //   this.$message.error(file.response.message)     
      // }
    },
    // 图片删除
    handleRemove(file, fileList) {
      console.log('Remove Success!', file, fileList)
      this.imgMax = false
      this.fileList = []
      this.form.banner = ''
    },
    // 上传文件的断网
    uploadErr() {
      if (!navigator.onLine || window.navigator.onLine === false) {
        const loading = this.$loading()
        setTimeout(() => {
          loading.close()
          this.$message.error(this.$i18n.t('lang.warning_network'))
        }, 500)
      }
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
  },
  created() {
    this.getData()
  },
  mounted() {}
}
</script>

<style lang='scss'>
.rotationList{
  .img {
    width: 80px;
    height: 50px;
    border: 1px solid lightgray;
    border-radius: 5px;
    padding: 5px;
  }
  .imgDisabled{
    .el-upload--picture-card {
      display: none!important;
    }
    .el-button--small {
      display: none!important;
    }
  }
}
</style>
